import React from 'react'
import { SearchBackToDealerLink } from '../../components/search-back-to-dealer-link/search-back-to-dealer-link'
import { useRetailerStockSearch } from '../../utils/retailer-stock'

const BackToDealer = ({ dealerLink }: { dealerLink?: string }) => {
    const [isRetailerStockSearch] = useRetailerStockSearch()
    if (isRetailerStockSearch && dealerLink) {
        return <SearchBackToDealerLink link={dealerLink} />
    } else {
        return <></>
    }
}

export { BackToDealer }
